export default __webpack_public_path__ + "static/media/family.e97ba4ac.jpg";